<template>
	<slider animation="normal" :auto="true" :interval="5000" height="425px">
      <slider-item v-for="item in clientProp" :key="item.id">
        <b-container>
          <b-row align-v="center" style="margin-bottom: 20px;" class="text-center">
            <b-col cols="12" sm="12" md="12" lg="12">
              <p class="sign">What client say?</p>
              <p class="separator">&mdash; &#x2022; &mdash;</p>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center text-center">
            <b-col cols="12" sm="12" md="1" lg="1" align-v="center">
              <img :src="item.image" class="profileSize">
            </b-col>
          </b-row>
          <b-row align-v="center" style="margin-top: 20px;" class="text-center">
            <b-col cols="12" sm="12" md="12" lg="12">
              <p class="greetingText">"{{ item.description }}"</p>
              <p class="line">&mdash;</p>
              <p class="clientDesp"><span class="clientName">{{ item.name }}</span><br><span>{{ item.profession }}</span></p>
            </b-col>
          </b-row>
        </b-container>
      </slider-item>
    </slider>
</template>
<script>
import { Slider, SliderItem } from 'vue-easy-slider'
export default {
  data () {
    return {
      list: [
        { backgroundColor: '#000000', width: '100%' },
        { backgroundColor: '#eee', width: '100%' },
        { backgroundColor: '#f44336', width: '100%' }
      ],
      clientProp: [
        { image: require('../assets/img/profile2.png'), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Angela Taylor', profession: 'CEO/Founder Webworldpk'},
        { image: require('../assets/img/face2.png'), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Marta Smith', profession: 'Teacher'},
        { image: require('../assets/img/face3.png'), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Magda Black', profession: 'Garbage Women'},
        { image: require('../assets/img/face4.png'), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Elizabeth Taylor', profession: 'Blacksmith'}
      ]
    }
  },
  components: {
    Slider,
    SliderItem
  }
}
</script>
<style lang="scss" scoped>
	.sign {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    font-style: italic;
    margin-top: 15px;
  }
  .separator {
    color: #e8e8e8;
  }
  .profileSize {
    width: 90px;
  }
  .greetingText {
    font-family: 'Raleway Medium', serif;
    font-size: 12px;
    font-style: italic;
  }
  .clientDesp {
    font-family: 'Raleway Medium', serif;
    font-size: 14px;
  }
  .clientName {
    font-weight: bold;
    color: #e1571a;
  }
  .line {
    color: #e8e8e8;
    height: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue?05da649b